import * as PropTypes from 'prop-types';
export var itemPropTypes = {
    collapsible: PropTypes.bool,
    isOpen: PropTypes.bool,
    onToggleCollapse: PropTypes.func
};
export var statefulItemPropTypes = {
    collapsible: PropTypes.bool,
    defaultOpen: PropTypes.bool
};
//# sourceMappingURL=types.js.map